import * as React from 'react';
import { IStackTokens, Stack, FocusZone, PrimaryButton, FontIcon } from '@fluentui/react';
import { useState } from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { ViewAnalyticsModel } from './AnalyticsModel';
import { AnalyticsActions } from './AnalyticsActions';

import { ErrorMessage } from 'src/App/Components/Common/ErrorMessage';
import { UATConstants } from 'src/Common/Models/UATConstants';

interface Props {
  analyticsViewData: ViewAnalyticsModel;
  readyToValid: boolean;
}

const ValidationTab: React.FC<Props> = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [error, setError] = useState<string>('');
  const [viewRowCount, setViewRowCount] = useState<number>(0);
  const [viewVerified, setViewVerified] = useState<boolean>(false);

  const handleSubmit = () => {
    try {
      setShowSpinner(true);
      setError('');
      const analyticsView: ViewAnalyticsModel = props.analyticsViewData;
      AnalyticsActions.VerifyAnalyticsView(analyticsView, onRequestSuccess, onRequestFailure);
    } catch (e) {
      console.error(e);
      setError(e);
    }
  };

  const onRequestFailure = (response: any) => {
    setError(response?.detailedErrorMessages?.detail);
    setShowSpinner(false);
  };

  const onRequestSuccess = (result: any) => {
    setViewRowCount(result);
    setViewVerified(true);
    setShowSpinner(false);
  };

  const stackTokens: IStackTokens = { childrenGap: 15 };
  return (
    <>
      <div className='ms-Grid'>
        {showSpinner && (
          <Spinner
            size={SpinnerSize.large}
            label={UATConstants.PlaceholdersAndTitles.TakeAMinute}
            ariaLive='assertive'
            className='loading-panel-full'
          />
        )}

        <Stack tokens={stackTokens} className='marginLeft8px'>
          <div>
            <FocusZone>
              <div className='paddingRight30px'>
                <div className='height15'></div>
                <Stack tokens={stackTokens}>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg12'>
                      {error !== '' && (
                        <ErrorMessage
                          containerClassName='ms-Grid-col ms-Grid-row'
                          onDismiss={() => {
                            setError('');
                          }}>
                          {error}
                        </ErrorMessage>
                      )}
                      {!viewVerified && (
                        <div className='validateCenterDiv'>
                          <div className='height20'></div>
                          <FontIcon iconName={UATConstants.PlaceholdersAndTitles.UserWarning} />
                          <div className='height20'></div>
                          <div className='textLightGrayColor'>
                            {UATConstants.PlaceholdersAndTitles.AnalyticsViewValidate}
                          </div>
                          <div className='height20'></div>
                        </div>
                      )}
                      {viewVerified && (
                        <div className='validateCenterDiv'>
                          <div className='height20'></div>
                          <FontIcon
                            iconName={UATConstants.BulkUploadUserMessages.Completed}
                            className='completedImageColor'
                            color='green'
                          />
                          <br />
                          <div className='height20'></div>
                          <div className='textLightGrayColor'>
                            {UATConstants.PlaceholdersAndTitles.AnalyticsverifiedPowerBI}
                          </div>
                          <div className='height20'></div>
                          <div className='ligthGrayColorFont20'>
                            {UATConstants.PlaceholdersAndTitles.EstimatedRows} {viewRowCount}
                          </div>
                          <div className='height20'></div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg12'>
                      <div className='validateButtonDiv'>
                        <PrimaryButton
                          id={'verifyButton'}
                          title={UATConstants.PlaceholdersAndTitles.VerifyView}
                          onClick={handleSubmit}
                          allowDisabledFocus
                          disabled={viewVerified || !props.readyToValid}>
                          {UATConstants.PlaceholdersAndTitles.VerifyView}
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </Stack>
              </div>
            </FocusZone>
          </div>
          <div className='height30'></div>
        </Stack>
      </div>
    </>
  );
};

export default ValidationTab;
